import logger, { ErrorType } from '@ane/core/lib/services/logging/Logger';

function isPromise(val) {
  return val && typeof val.then === 'function';
}

const _extends =
  Object.assign ||
  function (target) {
    for (let i = 1; i < arguments.length; i++) {
      const source = arguments[i];
      for (let key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

export default function globalErrorMiddleware(_ref) {
  let dispatch = _ref.dispatch;

  return (next) => (action) => {
    // If not a promise, continue on
    if (!isPromise(action.payload)) {
      return next(action);
    }

    return isPromise(action.payload)
      ? action.payload.then(
          function (result) {
            return dispatch(_extends({}, action, { payload: result }));
          },
          function (error) {
            logger.error(error, ErrorType.Promise);
            return dispatch(_extends({}, action, { error: true, payload: error }));
          },
        )
      : next(action);
  };
}
